<template>
    <div>
        <h2 data-v-b4af1080="" class="modal-title">Error</h2>
        <div class="alert alert-danger" role="alert">
            <p><strong>{{ errorMessage }}</strong></p>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            errorMessage: ""
        };
    },

    created () {
        this.errorMessage = this.$store.state.error_message || "Unexpected error.";
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Generic/Error.vue